const computeContentAlignmentFallback = ({ option }) => option.choices[0].value;

export default computeContentAlignmentFallback;
